<!--
    @file:每个页面的头部header
    @props:{boolean} ismenu 决定是否显示menu
-->
<template>
    <div id="header">
        <div class="logo"><img src="../../assets/img/logo.png"/></div>
        <div class="title"><img src="../../assets/img/title.png"/></div>
		<el-menu v-if="ismenu" class="el-menu1" mode="horizontal" >
              <el-menu-item index="0"><router-link to="/main">首页</router-link></el-menu-item>
              <el-submenu :index="menu.id" v-for="menu in menus" :key="menu.id">
                <template slot="title">{{ menu.menu }}</template>
                <el-menu-item index="item.id" v-for="item in menu.items" :key="item.id">
                    <router-link :to="{ path: item.path }" >{{ item.name }}</router-link>
                </el-menu-item>
              </el-submenu>
        </el-menu>
        <el-menu v-else>
			  <div class="sub-title">EV Batteries Remote Monitoring System</div>
        </el-menu>
        <el-menu class="el-menu2" mode="horizontal" >
              <el-menu-item index="11"><router-link to=""><b>3</b><span>告警</span></router-link></el-menu-item>
              <el-menu-item index="12"><router-link to=""><span>用户</span></router-link></el-menu-item>
              <el-menu-item index="13"><router-link to=""><span>退出</span></router-link></el-menu-item>
              <el-submenu index="14">
			    <template slot="title">{{ language }}</template>
			    <el-menu-item index="14-1" v-on:click="language='简体中文'">简体中文</el-menu-item>
			    <el-menu-item index="14-2" v-on:click="language='繁体中文'">繁体中文</el-menu-item>
			    <el-menu-item index="14-3" v-on:click="language='English'">English</el-menu-item>
			    <el-menu-item index="14-4" v-on:click="language='한국어'">한국어</el-menu-item>
			  </el-submenu>
        </el-menu>
    </div>
</template>

<script>
export default {
    name: 'header',
    created () {
        this.getMenuData();
    },
    data () {
        return {
            menus: [],
            language: '简体中文'
        };
    },
    props: ['ismenu'],
    methods: {
        getMenuData () {
            var self = this;
            this.$ajax({
                method: 'get',
                url: self.Api.menu
            }).then(function (res) {
                if (res.status === 200) {
                    self.menus = res.data;
                }
            });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#header{
    background: -webkit-linear-gradient(#e3e8f2 60%, #fff);
    background: -o-linear-gradient(#e3e8f2 60%, #fff);
    background: -moz-linear-gradient(#e3e8f2 60%, #fff);
    background: linear-gradient(#e3e8f2 60%, #fff);
    box-shadow:5px 5px 30px #bec7d3;
    position: relative;
    min-height:100px;
}
#header .title img{
	width: 360px;
	margin: 10px 0;
}
#header .sub-title{
	font-size:18px;
	color:#666;
}
.logo {
	text-align: left;
	padding: 10px;
}
.logo img{
	width: 180px;
}
.el-menu {
	background-color:transparent;
	border-radius:0;
}
.el-menu li a{
	text-decoration:none;
}
.el-menu1 {
	margin-top: 20px;
}
.el-menu--horizontal .el-menu-item,
.el-menu--horizontal .el-submenu .el-submenu__title,
.el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
	height:50px;
	line-height:50px;
	border-bottom:2px solid transparent;
	padding:0 15px;
}
.el-menu--horizontal>.el-menu-item:hover,
.el-menu--horizontal>.el-submenu:hover .el-submenu__title,
.el-menu--horizontal>.el-submenu.is-active:hover .el-submenu__title{
	border-bottom:2px solid #5182e4;
}
.el-menu--horizontal .el-menu-item{
	padding: 0;
}
.el-menu--horizontal .el-menu-item a{
	display: block;
	padding: 0 15px;
}
.el-menu--horizontal .el-submenu .el-menu{
	top:50px;
}
.el-menu--horizontal .el-submenu .el-menu-item{
	min-width: 0;
}
.el-menu--horizontal .el-menu-item a,
.el-menu--horizontal .el-submenu .el-menu-item,
.el-menu--horizontal>.el-submenu.is-active .el-menu-item{
	color: #48576a;
}
.el-menu--horizontal .el-submenu .el-menu-item:hover,
.el-menu--horizontal>.el-submenu.is-active .el-menu-item:hover{
	background-color: #5182e4;
	color: #fff;
}

.el-menu2.el-menu--horizontal>.el-menu-item{
	color: #48576a;
	background:no-repeat 15px center;
}
.el-menu2.el-menu--horizontal>.el-menu-item a{
	position: relative;
	display: block;
	padding-left: 40px;
	height: 50px;
}
.el-menu2.el-menu--horizontal>.el-menu-item:hover{
	border-bottom:2px solid transparent;
	color: #5182e4;
}
.el-menu2.el-menu--horizontal>.el-menu-item:nth-child(1){
	background-image:url(../../assets/img/alert.png);
}
.el-menu2.el-menu--horizontal>.el-menu-item:nth-child(1) b{
	position: absolute;
    left: 28px;
    top: 10px;
    padding: 1px 3px 0 3px;
    height: 12px;
    border-radius: 50%;
    background-color: red;
    color: #fff;
    font-size: 10px;
    line-height: 12px;
    text-align: center;
}
.el-menu2.el-menu--horizontal>.el-menu-item:nth-child(2){
	background-image:url(../../assets/img/user.png);
}
.el-menu2.el-menu--horizontal>.el-menu-item:nth-child(3){
	background-image:url(../../assets/img/logout.png);
}
.el-menu2.el-menu--horizontal>.el-menu-item:nth-child(1):hover{
	color: red;
	background-image:url(../../assets/img/alert_active.png);
}
.el-menu2.el-menu--horizontal>.el-menu-item:nth-child(2):hover{
	background-image:url(../../assets/img/user_active.png);
}
.el-menu2.el-menu--horizontal>.el-menu-item:nth-child(3):hover{
	background-image:url(../../assets/img/logout_active.png);
}
@media screen and (min-width: 1000px) {
	#header .title{
		padding-top: 10px;
	}
	#header .title img{
		width: 500px;
	}
	.logo {
		position: absolute;
		top:15px;
		left:0;
		float:none;
	}
	.el-menu1 {
	    position: absolute;
	    bottom:0;
	    left:200px;
	}
}
@media screen and (min-width: 1000px) and (max-width: 1366px) {
	.el-menu2{
		position: fixed;
		top:110px;
		right: 10px;
		z-index: 1000;
	}
	.el-menu2.el-menu--horizontal>.el-menu-item{
		float: none;
	}
	.el-menu2.el-menu--horizontal>.el-menu-item a{
		margin: 5px;
		padding: 0;
		height: 40px;
		width: 40px;
		box-shadow: 4px 4px 10px #bec7d3;
	}
	.el-menu2.el-menu--horizontal>.el-menu-item span,
	.el-menu2.el-menu--horizontal>.el-submenu{
		display: none;
	}
	.el-menu2.el-menu--horizontal>.el-menu-item:nth-child(1) a{
		background:url(../../assets/img/alert_active.png) no-repeat center center #fff;
	}
	.el-menu2.el-menu--horizontal>.el-menu-item:nth-child(2) a{
		background:url(../../assets/img/user_active.png) no-repeat center center #fff;
	}
	.el-menu2.el-menu--horizontal>.el-menu-item:nth-child(3) a{
		background:url(../../assets/img/logout_active.png) no-repeat center center #fff;
	}
}
@media screen and (min-width: 1366px) {
	.el-menu2 {
	    position: absolute;
	    bottom:0;
	    right:0;
	}
}
</style>



// WEBPACK FOOTER //
// header.vue?1a7a36a8